import { useUnit } from 'effector-react'
import { Button, Divider, Flex, Modal } from 'antd'
import { AvailableStepButtons } from 'src/pages/budget/budgetRequests/components/availableStepButtons'
import { useModalRequestsApprove } from 'src/pages/budget/budgetRequests/hooks'
import {
  closeModalRequestsApprove,
  decideRequestsBatchFx,
} from 'src/pages/budget/budgetRequests/model'
import { LinkifiedText, UiText } from 'src/pages/budget/components'
import { ActionStep } from 'src/pages/budget/budgetRequests/types'
import { showNotification } from 'src/features/notifications'

export const ModalRequestsApprove = () => {
  const modalRequestsApprove = useModalRequestsApprove()

  if (!modalRequestsApprove) return null

  const { items } = modalRequestsApprove
  const open = Boolean(modalRequestsApprove)

  const { id, availableApprovalSteps, description } = items[0]
  const handleCancel = () => closeModalRequestsApprove()

  const handleOk = async ({ stepId }: ActionStep) => {
    try {
      const selectedStep = availableApprovalSteps.find(
        (candidate) => candidate.id === stepId,
      )
      if (!selectedStep) return
      const skippedIds: number[] = []
      const itemsToApprove = items.flatMap((item) => {
        const step = item.availableApprovalSteps.find(
          (candidate) => candidate.teamId === selectedStep.teamId,
        )
        if (!step) skippedIds.push(item.id)
        return step ? [{ id: item.id, stepId: step.id }] : []
      })
      if (skippedIds.length) {
        showNotification({
          type: 'warning',
          message: `Не выбраны для согласования: №${skippedIds.join(', ')}`,
          description: 'Для этих заявок нет подходящего активного шага.',
        })
      }
      if (!itemsToApprove.length) return
      await decideRequestsBatchFx({
        url: '/budget/budget_request/batch_approve',
        body: { items: itemsToApprove },
      })
      closeModalRequestsApprove()
    } catch (error) {
      console.error(error)
    }

  }
  const ids = items.map(({ id }) => id)

  return (
    <Modal
      title={
        <div style={{ fontSize: 20 }}>
          Согласовать {ids.length > 1 ? 'заявки' : 'заявку'}
        </div>
      }
      centered
      wrapClassName="ant_modal"
      width={500}
      maskClosable={false}
      open={open}
      destroyOnHidden
      onCancel={handleCancel}
      footer={
        <Flex gap={8}>
          <Button size="large" style={{ flex: 1 }} onClick={handleCancel}>
            Отменить
          </Button>
          <AvailableStepButtons
            id={id}
            approvalSteps={availableApprovalSteps}
            text="Согласовать"
            color="green"
            callback={handleOk}
          />
        </Flex>
      }
    >
      <Divider />
      <UiText size={18}>
        Вы уверены, что хотите согласовать{' '}
        {ids.length > 1 ? 'заявки №' : 'заявку №'}
        <UiText size={18} strong>
          {' '}
          {ids.join(', ')} <LinkifiedText text={description} />?
        </UiText>
      </UiText>
      <Divider />
    </Modal>
  )
}
